import React from 'react';

const PopupUserFormModal = React.lazy(() => import('../components/FormModal'));
const popupUserModalRegistry = {
    crm_popupUserId: PopupUserFormModal
};
export default popupUserModalRegistry;
